module.exports = __webpack_public_path__ + "img/w68b.d3b8bb15.jpg";